/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getOmStores } from '../fn/order-manager/get-om-stores';
import { GetOmStores$Params } from '../fn/order-manager/get-om-stores';
import { OmStoresResponse } from '../models/om-stores-response';

@Injectable({ providedIn: 'root' })
export class OrderManagerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getOmStores()` */
  static readonly GetOmStoresPath = '/om/stores';

  /**
   * Gets list of available Order Manager stores.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOmStores()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOmStores$Response(params: GetOmStores$Params, context?: HttpContext): Observable<StrictHttpResponse<OmStoresResponse>> {
    return getOmStores(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets list of available Order Manager stores.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOmStores$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOmStores(params: GetOmStores$Params, context?: HttpContext): Observable<OmStoresResponse> {
    return this.getOmStores$Response(params, context).pipe(
      map((r: StrictHttpResponse<OmStoresResponse>): OmStoresResponse => r.body)
    );
  }

}
